import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout/layout.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/reg',
    name: 'reg',
    component: () => import('@/views/reg/reg.vue')
  },
  {
    path: '/forget_pwd',
    name: 'forget_pwd',
    component: () => import('@/views/forget_pwd/forget_pwd.vue')
  },
  {
    path: '/reset_pwd',
    name: 'reset_pwd',
    component: () => import('@/views/reset_pwd/reset_pwd.vue')
  },
  {
    path: '/upload',
    name:'upload',
    component: () => import('@/views/upload/upload.vue'),
  },
  {
    path: '/',//Dashboard
    component: layout,
    children: [{
      path: '/',
      component: () => import('@/views/home/home.vue'),
    }]
  },
  {
    path: '/',//My transaction
    component: layout,
    children: [{
      path: 'my_transaction',
      component: () => import('@/views/my_transaction/my_transaction.vue'),
    }]
  },
  {
    path: '/',//My transaction info
    component: layout,
    children: [{
      path: 'my_transaction_info',
      component: () => import('@/views/my_transaction/my_transaction_info.vue'),
    }]
  },
  {
    path: '/',//Blockchain deposit
    component: layout,
    children: [{
      path: 'blockchain_d',
      // redirect:'/blockchain_d/deposit_fiat',
      redirect:'/blockchain_d/deposit_jmhb',
      component: () => import('@/views/blockchain_d/blockchain_d.vue'),
      children: [{
        path: 'deposit_fiat',
        component: () => import('@/views/blockchain_d/children/deposit_fiat.vue'),
      },{
        path: 'deposit_jmhb',
        component: () => import('@/views/blockchain_d/children/deposit_jmhb.vue'),
      }]
    }]
  },
  {
    path: '/',//transaction_h   transaction_h_info
    component: layout,
    children: [{
      path: 'blockchain_d/transaction_h_info',
      component: () => import('@/views/blockchain_d/children/transaction_h_info.vue'),
    }]
  },
  {
    path: '/',//bank_details
    component: layout,
    children: [{
      path: 'blockchain_d/bank_details',
      component: () => import('@/views/blockchain_d/children/bank_details.vue'),
    }]
  },
  {
    path: '/',//Transfer & Payments
    component: layout,
    children: [{ 
      path: 'blockchain_w',
      redirect: 'blockchain_w/transfer_p_fiat',
      component: () => import('@/views/blockchain_w/blockchain_w.vue'),
      children: [
        // {
        //   path: 'transfer_p',//Transfer & Payments
        //   component: () => import('@/views/blockchain_w/children/transfer_p.vue'),
        // },{
        //   path: 'fiat_t_h',//Fiat Transaction History
        //   component: () => import('@/views/blockchain_w/children/fiat_t_h.vue'),
        // },{
        //   path: 'digital_t_h',//Digital Asset Transaction History
        //   component: () => import('@/views/blockchain_w/children/digital_t_h.vue'),
        // },
      {
        path: 'transfer_p_fiat',
        component: () => import('@/views/blockchain_w/children/transfer_p_fiat.vue'),
      },{
        path: 'transfer_p_jmhb',
        component: () => import('@/views/blockchain_w/children/transfer_p_jmhb.vue'),
      }]
    }]
  },
  {
    path: '/',//Manage My Payee list
    component: layout,
    children: [{
      path: 'blockchain_w/m_m_payee_list',
      component: () => import('@/views/blockchain_w/children/m_m_payee_list.vue'),
    }]
  },
  {
    path: '/',//Manage My Addresses list
    component: layout,
    children: [{
      path: 'blockchain_w/m_m_addr_list',
      component: () => import('@/views/blockchain_w/children/m_m_addr_list.vue'),
    }]
  },
  {
    path: '/',//步骤条 1  New Transfer & Payment (Fiat)
    component: layout,
    children: [{
      path: 'blockchain_w/new_fiat',
      component: () => import('@/views/blockchain_w/children/new_fiat.vue'),
    }]
  },
  {
    path: '/',//步骤条 2  New Transfer & Payment (Fiat)
    component: layout,
    children: [{
      path: 'blockchain_w/new_fiat2',
      component: () => import('@/views/blockchain_w/children/new_fiat2.vue'),
    }]
  },
  {
    path: '/',//步骤条 1  New Transfer & Payment (Digital Asset)
    component: layout,
    children: [{
      path: 'blockchain_w/new_digital_asset',
      component: () => import('@/views/blockchain_w/children/new_digital_asset.vue'),
    }]
  },
  {
    path: '/',//步骤条 2  New Transfer & Payment (Digital Asset)
    component: layout,
    children: [{
      path: 'blockchain_w/new_digital_asset2',
      component: () => import('@/views/blockchain_w/children/new_digital_asset2.vue'),
    }]
  },
  {
    path: '/',//Fiat Transaction History fiat_t_h info
    component: layout,
    children: [{
      path: 'blockchain_w/fiat_t_h_info',
      component: () => import('@/views/blockchain_w/children/fiat_t_h_info.vue'),
    }]
  },
  {
    path: '/',//Digital Asset Transaction History digital_t_h info
    component: layout,
    children: [{
      path: 'blockchain_w/digital_t_h_info',
      component: () => import('@/views/blockchain_w/children/digital_t_h_info.vue'),
    }]
  },
  {
    path: '/',//Fiat deposit
    component: layout,
    children: [{
      path: 'fiat_deposit',
      component: () => import('@/views/fiat_deposit/fiat_deposit.vue'),
    }]
  },
  {
    path: '/',//FIat Withdrawal
    component: layout,
    children: [{
      path: 'fiat_withdrawal',
      component: () => import('@/views/fiat_withdrawal/fiat_withdrawal.vue'),
    }]
  },
  {
    path: '/',//OTC
    component: layout,
    children: [{
      path: 'otc',
      component: () => import('@/views/otc/otc.vue'),
    }]
  },
  {
    path: '/',//FX
    component: layout,
    children: [{
      path: 'fx',
      component: () => import('@/views/fx/fx.vue'),
    }]
  },
  {
    path: '/',//user_info
    component: layout,
    children: [{
      path: 'user_info',
      component: () => import('@/views/user_info/user_info.vue'),
    }]
  },
  {
    path: '/',//KYC
    component: layout,
    children: [{
      path: 'kyc',
      component: () => import('@/views/kyc/kyc.vue'),
    }]
  },
  {
    path: '/',//KYC 4个步骤 总
    component: layout,
    children: [{
      path: 'kyc_step',
      redirect:'/kyc_step/kyc_step_one',
      component: () => import('@/views/kyc_step/kyc_step.vue'),
      children: [{
        path: 'kyc_step_one',
        component: () => import('@/views/kyc_step/children/kyc_step_one.vue'),
      },{
        path: 'kyc_step_two',
        component: () => import('@/views/kyc_step/children/kyc_step_two.vue'),
      },{
        path: 'kyc_step_three',
        component: () => import('@/views/kyc_step/children/kyc_step_three.vue'),
      },{
        path: 'kyc_step_four',
        component: () => import('@/views/kyc_step/children/kyc_step_four.vue'),
      }]
    }]
  },
  {
    path: '/',//Private Banking Products
    component: layout,
    children: [{
      path: 'private_b_p',
      component: () => import('@/views/private_b_p/private_b_p.vue'),
    }]
  },
  {
    path: '/',//Structured Products
    component: layout,
    children: [{
      path: 'structured_p',
      component: () => import('@/views/structured_p/structured_p.vue'),
    }]
  },
  {
    path: '/',//Investment Banking
    component: layout,
    children: [{
      path: 'investment_b',
      component: () => import('@/views/investment_b/investment_b.vue'),
    }]
  },
  // {
  //   path: '/',// Apply Card input
  //   component: layout,
  //   children: [{
  //     path: 'apply_card_input',
  //     component: () => import('@/views/apply_card/apply_card_input.vue'),
  //   }]
  // },{
  //   path: '/',// Apply Card info
  //   component: layout,
  //   children: [{
  //     path: 'apply_card_info',
  //     component: () => import('@/views/apply_card/apply_card_info.vue'),
  //   }]
  // },
  {
    path: '/',//Cards
    component: layout,
    children: [{
      path: 'cards',
      component: () => import('@/views/cards/cards.vue'),
    }]
  },{
    path: '/',//Cards Top-up history
    component: layout,
    children: [{
      path: 'top_up_history',
      component: () => import('@/views/cards/top_up_history.vue'),
    }]
  },
  // {//所有用户申请的两个页面 1 输入框
  //   path: '/all_apply_card_input',
  //   name:'all_apply_card_input',
  //   component: () => import('@/views/all_apply_card/all_apply_card_input.vue'),
  // },
  // {//所有用户申请的两个页面 2 详情
  //   path: '/all_apply_card_info',
  //   name:'all_apply_card_info',
  //   component: () => import('@/views/all_apply_card/all_apply_card_info.vue'),
  // },
  {
    path: '/',//获取卡的交易记录
    component: layout,
    children: [{
      path: '/transaction_record',
      component: () => import('@/views/cards/transaction_record.vue'),
    }]
  }, {
    path: '/', // kyc管理
    component: layout,
    name: 'kycManage',
    children: [{
      path: 'kycManage',
      component: () => import('@/views/kycManage/kycManage.vue'),
    }]
  },{ // kyc管理 提交
    path: '/',
    component: layout,
    name: 'kyc_apply_card_input',
    children: [{
      path: 'kyc_apply_card_input',
      component: () => import('@/views/kycManage/apply_card_input.vue'),
    }]
  },
  { // 公告列表 页面
    path: '/',
    component: layout,
    children: [{
      path: 'affiche',
      redirect:'/affiche/affiche_list',
      component: () => import('@/views/affiche/affiche_index.vue'),
      children: [{
        path: 'affiche_list',
        component: () => import('@/views/affiche/affiche_list.vue'),
      },{
        path: 'affiche_list_admin',
        component: () => import('@/views/affiche/affiche_list_admin.vue'),
      }]
    }]
  },
  {
    path: '/',//卡 组件 续费页面
    component: layout,
    children: [{
      path: '/renew',
      component: () => import('@/views/cards/renew.vue'),
    }]
  },

  {
    path: '*',
    name: '404',
    component: () => import('@/views/404.vue')
  }
  
  
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach()

export default router